import styled from 'styled-components';
import { defaultBorderRadius } from '~/components/layout/Variables';

export const Card = styled.div`
  padding: 0rem 0 1.2rem 0;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: ${() => defaultBorderRadius};
  box-shadow: 0px 1px 2px #00000033;
`;

export const FlexAlign = styled.div`
  display: flex;
  align-content: center;
  justify-content: space-between;
  /* padding: 0 1rem; */

  span {
    color: #000FFF;
  }
`;

export const TitleDivision = styled.h3`
  font-size: 1.1rem;
  font-weight: 550;
  color: #707070;
`;

export const Tag = styled.span`
  border: 2px solid #37a21a;
  padding: 0rem 0.5rem;
  border-radius: ${() => defaultBorderRadius};
  color: #37a21a;
  font-weight: 550;
  text-transform: uppercase;
`;

export const Text = styled.div`
  word-wrap: break-word;
  margin: 0.3rem 0;
  font-weight: 500;
  color: #707070;
  padding: 0 !important;

  p {
    padding: 0 !important;
  }
`;

export const Division = styled.div`
  border-bottom: 1px solid #c9c9c9;
  width: 100%;
`;

export const ItemsSummary = styled.div`
  margin: 0rem 0rem 1rem 0rem;
`;

export const Details = styled.div`
  width: 100%;
  margin: 0rem .5rem 0rem .5rem;

  ${TitleDivision} {
    margin-bottom: 1rem;
  }

  ${Text} {
    padding: 0 1.3rem;
  }

  p {
    padding: 0 1.3rem;
  }
`;

export const ButtonDivision = styled.div`
  width: 85%;
  margin: 2rem auto 3.5rem auto;
`;

export const TitleSummary = styled.h2`
  font-size: 1.4rem;
  text-align: center;
  margin-bottom: 1rem;
  color: #808080;
  font-weight: 500;
`;

export const LoadingIcon = styled.i`
  font-size: 18px;
`;
